import * as React from 'react';
import { DataTableCell, Icon } from '@salesforce/design-system-react';
import { DataPreparationStatus } from 'lib/types';

/*
 * This component renders a green or grey "status" icon next to the status name.
 * If the current status matches "linkStatus", then the label will be rendered as link
 */
interface StatusCellProps {
	activeStatus: string;
	className?: string;
	handleClick?: (item: {}) => void;
	item?: {
		status: DataPreparationStatus
	};
	labels: {[status: string]: string};
	linkStatus: string;
}

const StatusCell: React.SFC<StatusCellProps> = ({ children, ...props}) => {
	props.className = 'overview-table__status-cell';
	const currentStatus = props.item && props.item.status || '';
	const isActive = currentStatus === props.activeStatus;
	const statusIcon = <Icon category="utility" name="record" style={isActive ? {fill: '#4bca81'} : {}} />;
	const helpIcon = <Icon category="utility" name="info" className="help" />;
	const handleClick = (e: React.MouseEvent<{}>) => {
		if (props.handleClick) { props.handleClick(props.item || {}); }
	};

	return (
		<DataTableCell {...props}>
			{currentStatus === props.linkStatus ?
				<a href="javascript:void(0);" onClick={handleClick}>{statusIcon} {props.labels[currentStatus]} {helpIcon}</a> :
				<span>{statusIcon} {props.labels[currentStatus]}</span>
			}
		</DataTableCell>
	);
};
StatusCell.displayName = DataTableCell.displayName;

export default StatusCell;


// WEBPACK FOOTER //
// ./src/lib/Overview/status-cell.tsx